import { App } from "antd";
import { useEffect } from "react";

let messageApi = null;
const pendingCalls = [];

function flushPendingCalls() {
  if (!messageApi) {
    return;
  }

  while (pendingCalls.length > 0) {
    const { method, args } = pendingCalls.shift();
    messageApi[method](...args);
  }
}

function callMessage(method, args) {
  if (messageApi) {
    return messageApi[method](...args);
  }

  pendingCalls.push({ method, args });
  return Promise.resolve();
}

export function AppMessageBridge() {
  const { message } = App.useApp();

  useEffect(() => {
    messageApi = message;
    flushPendingCalls();

    return () => {
      if (messageApi === message) {
        messageApi = null;
      }
    };
  }, [message]);

  return null;
}

export const appMessage = {
  success: (...args) => callMessage("success", args),
  error: (...args) => callMessage("error", args),
  warning: (...args) => callMessage("warning", args),
  info: (...args) => callMessage("info", args),
  loading: (...args) => callMessage("loading", args),
  open: (...args) => callMessage("open", args),
};
